module.exports = __webpack_public_path__ + "static/img/our-people-we-live-diversity.9d756ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-we-live-diversity.jpg
// module id = gxdA
// module chunks = 0